/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RuntimeError/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Contactofficegraphic01 from 'DesignSystem/Svgs/Contactofficegraphic01/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RuntimeError({
  children,
  viewPath = "/App/RuntimeError"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="RuntimeError.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Contactofficegraphic01
  viewPath={`${viewPath}/Contactofficegraphic01`}
 width={360}
 height={200}
/>
<div
  data-testid="RuntimeError.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="RuntimeError.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Apologies, online scheduling is not available at the moment.
</span>
<span
  data-testid="RuntimeError.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Please, contact our office directly.
</span>
</div>
</div>
{children}
</React.Fragment>)
}